import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { createContainer } from '@dbk-legacy/muster/react';

let scrollToBottomOnce = true;

class FlexHeight extends PureComponent {

  constructor(props) {
    super(props);
  }

  static propTypes = {
    ratio: PropTypes.number
  };

  scrollToBottom = () => {
    if (this.props.scrollOnce && scrollToBottomOnce) {
      this.footer.scrollIntoView({ behavior: "smooth" });
    }
  }

  componentDidMount() {
    scrollToBottomOnce = true;
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
    scrollToBottomOnce = false;
  }

  render() {
    return (
      <div id="flexHt" className="flex-height" style={{ 'max-height': this.props.screen.height * this.props.ratio }}>
        {this.props.children}
        <div className="flex-height__footer" ref={(element) => { this.footer = element; }}>
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    screen: {
      height: true
    }
  },
})(FlexHeight);
